import { Form, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FirmUserForm from "./FirmUserForm";
import useFirmService from "../../../services/useFirmService";
import PageRoutes from "../../../utils/routes";

const UpdateFirmUser = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const params = useParams();
  const firmUserId = params.firmUserId;

  const { useGetFirmUserById, useUpdateFirmUser } = useFirmService();
  const { data: firmUser, isLoading, isError } = useGetFirmUserById(firmUserId);
  const { mutateAsync: updateFirmUser } = useUpdateFirmUser();

  const onFinish = async (values) => {
    const requestBody = {
      id: firmUserId,
      email: values.email,
      name: values.name,
      surname: values.surname,
      status: values.status,
      firmRole: values.firmRole,
    };
    try {
      await updateFirmUser(requestBody);
      navigate(PageRoutes.firmUsers);
    } catch (error) {
      console.log(error);
    }
  };

  if (firmUserId === undefined || isError) {
    navigate(PageRoutes.firmUsers);
  }

  return (
    <>
      <div>
        <FirmUserForm
          form={form}
          onFinish={onFinish}
          initialValues={firmUser?.data}></FirmUserForm>
      </div>

      <Spin spinning={isLoading} fullscreen />

      {/* <ModalComponent></ModalComponent> */}
    </>
  );
};

export default UpdateFirmUser;
